export const stopPropagation: React.MouseEventHandler = e =>
  e.stopPropagation();
